import { render, staticRenderFns } from "./items_university.vue?vue&type=template&id=5add26f8"
import script from "./items_university.vue?vue&type=script&lang=js"
export * from "./items_university.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Product: require('/home/ubuntu/containers/hermes_eshop/components/core/product.vue').default})
